export const GET_AUTH_REQUEST = 'GET_AUTH_REQUEST';
export const GET_AUTH_SUCCESS = 'GET_AUTH_SUCCESS';
export const GET_AUTH_FAILURE = 'GET_AUTH_FAILURE';
export const AUTH_RESET = 'AUTH_RESET';

export const TOKEN_REFRESH_REQUEST = 'TOKEN_REFRESH_REQUEST';
export const TOKEN_REFRESH_SUCCESS = 'TOKEN_REFRESH_SUCCESS';
export const TOKEN_REFRESH_FAILURE = 'TOKEN_REFRESH_FAILURE';

export const GET_REGISTER_REQUEST = 'GET_REGISTER_REQUEST';
export const GET_REGISTER_SUCCESS = 'GET_REGISTER_SUCCESS';
export const GET_REGISTER_FAILURE = 'GET_REGISTER_FAILURE';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const SET_NEW_PASSWORD_REQUEST = 'SET_NEW_PASSWORD_REQUEST';
export const SET_NEW_PASSWORD_SUCCESS = 'SET_NEW_PASSWORD_SUCCESS';
export const SET_NEW_PASSWORD_FAILURE = 'SET_NEW_PASSWORD_FAILURE';

export const CHECK_PASSWORD_RESET_VALID_REQUEST =
  'CHECK_PASSWORD_RESET_VALID_REQUEST';
export const CHECK_PASSWORD_RESET_VALID_SUCCESS =
  'CHECK_PASSWORD_RESET_VALID_SUCCESS';
export const CHECK_PASSWORD_RESET_VALID_FAILURE =
  'CHECK_PASSWORD_RESET_VALID_FAILURE';

export const CONFIRM_USER_ACCOUNT_REQUEST = 'CONFIRM_USER_ACCOUNT_REQUEST';
export const CONFIRM_USER_ACCOUNT_SUCCESS = 'CONFIRM_USER_ACCOUNT_SUCCESS';
export const CONFIRM_USER_ACCOUNT_FAILURE = 'CONFIRM_USER_ACCOUNT_FAILURE';

export const RESEND_ACCOUNT_CONFIRMATION_REQUEST =
  'RESEND_ACCOUNT_CONFIRMATION_REQUEST';
export const RESEND_ACCOUNT_CONFIRMATION_SUCCESS =
  'RESEND_ACCOUNT_CONFIRMATION_SUCCESS';
export const RESEND_ACCOUNT_CONFIRMATION_FAILURE =
  'RESEND_ACCOUNT_CONFIRMATION_FAILURE';

export const LEAD_PLAN_SELECT = 'LEAD_PLAN_SELECT';
